// Export an array of topics for VA 1st Grade Social Studies
const va1stSocialStudiesQuizContent = [
 
  // Settled - Multiple Choice
  {
    "slug": "settled",
    "title": "Settled",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      { 
        "question": "Read the question, then choose the correct answer. In what year was the first permanent English settlement at Jamestown established?",
        "questionImage": "",
        "answers": [
          { "text": "1607", "correct": true, "image": "" },
          { "text": "1776", "correct": false, "image": "" },
          { "text": "1492", "correct": false, "image": "" }
        ]
      },
      { 
        "question": "Read the question, then choose the correct answer. What was the main goal of the settlers who started Jamestown?",
        "questionImage": "",
        "answers": [
          { "text": "To find wealth", "correct": true, "image": "" },
          { "text": "To play sports", "correct": false, "image": "" },
          { "text": "To make art", "correct": false, "image": "" }
        ]
      },
      { 
        "question": "Read the question, then choose the correct answer. What valuable resources did many Jamestown settlers hope to find?",
        "questionImage": "",
        "answers": [
          { "text": "Gold and silver", "correct": true, "image": "" },
          { "text": "Spices", "correct": false, "image": "" },
          { "text": "Tea", "correct": false, "image": "" }
        ]
      },
      { 
        "question": "Read the question, then choose the correct answer. What kind of landform was chosen for the Jamestown settlement site?",
        "questionImage": "",
        "answers": [
          { "text": "Peninsula", "correct": true, "image": "" },
          { "text": "Island", "correct": false, "image": "" },
          { "text": "Desert", "correct": false, "image": "" }
        ]
      },
      { 
        "question": "Read the question, then choose the correct answer. Which company paid for the trip to start the Jamestown colony?",
        "questionImage": "",
        "answers": [
          { "text": "Virginia Company", "correct": true, "image": "" },
          { "text": "Parliament", "correct": false, "image": "" },
          { "text": "Colonists", "correct": false, "image": "" }
        ]
      }
    ]
  },
  
  
  // Founders - Drag and Drop
  {
    "slug": "founders",
    "title": "Founders",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each leader to what they are best known for.",
        "options": [
          { "id": "washington", "text": "George Washington", "image": "", "targetText": "First President", "targetImage": "" },
          { "id": "jefferson", "text": "Thomas Jefferson", "image": "", "targetText": "Wrote Declaration", "targetImage": "" },
          { "id": "lincoln", "text": "Abraham Lincoln", "image": "", "targetText": "Ended Slavery", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each person to something they helped create or lead.",
        "options": [
          { "id": "jefferson_vsrf", "text": "Thomas Jefferson", "image": "", "targetText": "VA Statute for Religious Freedom", "targetImage": "" },
          { "id": "wash_father", "text": "George Washington", "image": "", "targetText": "Father of Our Country", "targetImage": "" },
          { "id": "lincoln_union", "text": "Abraham Lincoln", "image": "", "targetText": "Kept Union Together", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each leader to the time or event they are remembered for.",
        "options": [
          { "id": "wash_revolution", "text": "George Washington", "image": "", "targetText": "Revolutionary War", "targetImage": "" },
          { "id": "jeff_founding", "text": "Thomas Jefferson", "image": "", "targetText": "Founding Era", "targetImage": "" },
          { "id": "lincoln_civil", "text": "Abraham Lincoln", "image": "", "targetText": "Civil War", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each leader to where they served.",
        "options": [
          { "id": "wash_capital", "text": "George Washington", "image": "", "targetText": "Led from the Capital", "targetImage": "" },
          { "id": "jeff_monticello", "text": "Thomas Jefferson", "image": "", "targetText": "Lived at Monticello", "targetImage": "" },
          { "id": "lincoln_whitehouse", "text": "Abraham Lincoln", "image": "", "targetText": "Lived in the White House", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each leader to the symbol or idea connected with them.",
        "options": [
          { "id": "wash_flag", "text": "George Washington", "image": "", "targetText": "American Flag", "targetImage": "" },
          { "id": "jeff_liberty", "text": "Thomas Jefferson", "image": "", "targetText": "Liberty", "targetImage": "" },
          { "id": "lincoln_freedom", "text": "Abraham Lincoln", "image": "", "targetText": "Freedom", "targetImage": "" }
        ]
      }
    ]
  },
  
  
  
  // Settlers and Natives - Multiple Choice
  {
    "slug": "settlersandnatives",
    "title": "Settlers and Natives",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      { 
        "question": "Read the question, then choose the correct answer. Which Native leader helped teach the Jamestown settlers how to survive?",
        "questionImage": "", 
        "answers": [
          { "text": "Powhatan", "correct": true, "image": "" },
          { "text": "Magellan", "correct": false, "image": "" },
          { "text": "Pizarro", "correct": false, "image": "" }
        ]
      },
      { 
        "question": "Read the question, then choose the correct answer. Who helped make peace and contact between the settlers and the Powhatan people?",
        "questionImage": "", 
        "answers": [
          { "text": "Pocahontas", "correct": true, "image": "" },
          { "text": "Sacagawea", "correct": false, "image": "" },
          { "text": "Martha", "correct": false, "image": "" }
        ]
      },
      { 
        "question": "Read the question, then choose the correct answer. What important crop did the settlers learn to grow from the Native peoples?",
        "questionImage": "", 
        "answers": [
          { "text": "Corn", "correct": true, "image": "" },
          { "text": "Wheat", "correct": false, "image": "" },
          { "text": "Cotton", "correct": false, "image": "" }
        ]
      },
      { 
        "question": "Read the question, then choose the correct answer. Which items were often traded between the settlers and the Powhatan?",
        "questionImage": "", 
        "answers": [
          { "text": "Tools and copper", "correct": true, "image": "" },
          { "text": "Silk and tea", "correct": false, "image": "" },
          { "text": "Gold and gems", "correct": false, "image": "" }
        ]
      },
      { 
        "question": "Read the question, then choose the correct answer. Who was the leader of the settlers that began trading with the Powhatan people?",
        "questionImage": "", 
        "answers": [
          { "text": "John Smith", "correct": true, "image": "" },
          { "text": "John Rolfe", "correct": false, "image": "" },
          { "text": "Christopher Columbus", "correct": false, "image": "" }
        ]
      }
    ]
  },
  
  
  // Christopher Newport - Drag and Drop
  {
    "slug": "christophernewport",
    "title": "Christopher Newport",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match what Christopher Newport is best known for.",
        "options": [
          { "id": "newport_explorer", "text": "Christopher Newport", "image": "", "targetText": "Explorer", "targetImage": "" },
          { "id": "newport_captain", "text": "Sea Captain", "image": "", "targetText": "Led the ships", "targetImage": "" },
          { "id": "newport_founder", "text": "Leader", "image": "", "targetText": "Helped start Jamestown", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each voyage detail to where or what it describes.",
        "options": [
          { "id": "eng_to_va", "text": "England → Jamestown", "image": "", "targetText": "Voyage route", "targetImage": "" },
          { "id": "atlantic_ocean", "text": "Atlantic Ocean", "image": "", "targetText": "Crossed by ship", "targetImage": "" },
          { "id": "virginia_coast", "text": "Virginia Coast", "image": "", "targetText": "Landing area", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match what Christopher Newport brought to the colony.",
        "options": [
          { "id": "people_supplies", "text": "People and supplies", "image": "", "targetText": "To new colony", "targetImage": "" },
          { "id": "food_goods", "text": "Food and goods", "image": "", "targetText": "For survival", "targetImage": "" },
          { "id": "tools_weapons", "text": "Tools and weapons", "image": "", "targetText": "For work and safety", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each ship to what it carried or did.",
        "options": [
          { "id": "susan_constant", "text": "Susan Constant", "image": "", "targetText": "Main supply ship", "targetImage": "" },
          { "id": "godspeed", "text": "Godspeed", "image": "", "targetText": "Carried settlers", "targetImage": "" },
          { "id": "discovery", "text": "Discovery", "image": "", "targetText": "Exploration ship", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each fact to what it tells about Christopher Newport.",
        "options": [
          { "id": "leader_role", "text": "Captain", "image": "", "targetText": "Led voyage", "targetImage": "" },
          { "id": "help_found", "text": "Founder", "image": "", "targetText": "Helped start colony", "targetImage": "" },
          { "id": "brave_explorer", "text": "Explorer", "image": "", "targetText": "Sailed across ocean", "targetImage": "" }
        ]
      }
    ]
  },
  
  
  // Contributions - Drag and Drop
  {
    "slug": "contributions",
    "title": "Contributions",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each leader to the kind of contribution they made to society.",
        "options": [
          { "id": "ashe_social", "text": "Arthur Ashe", "image": "", "targetText": "Social change", "targetImage": "" },
          { "id": "walker_business", "text": "Maggie Walker", "image": "", "targetText": "Business success", "targetImage": "" },
          { "id": "wilder_governor", "text": "L. Douglas Wilder", "image": "", "targetText": "Political leadership", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each person to the important ‘first’ they achieved.",
        "options": [
          { "id": "wilder_firstgov", "text": "L. Douglas Wilder", "image": "", "targetText": "First Black Governor", "targetImage": "" },
          { "id": "walker_firstbank", "text": "Maggie Walker", "image": "", "targetText": "First woman bank owner", "targetImage": "" },
          { "id": "ashe_firstchamp", "text": "Arthur Ashe", "image": "", "targetText": "First Black tennis champion", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each leader to the field they influenced most.",
        "options": [
          { "id": "oliverhill_law", "text": "Oliver Hill", "image": "", "targetText": "Law and rights", "targetImage": "" },
          { "id": "ashe_sports", "text": "Arthur Ashe", "image": "", "targetText": "Sports and equality", "targetImage": "" },
          { "id": "walker_finance", "text": "Maggie Walker", "image": "", "targetText": "Finance and business", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each person to what they worked to improve.",
        "options": [
          { "id": "oliverhill_schools", "text": "Oliver Hill", "image": "", "targetText": "Equal schools", "targetImage": "" },
          { "id": "ashe_health", "text": "Arthur Ashe", "image": "", "targetText": "Health awareness", "targetImage": "" },
          { "id": "walker_jobs", "text": "Maggie Walker", "image": "", "targetText": "Jobs for others", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each contribution to the person who made it.",
        "options": [
          { "id": "brownvboard", "text": "Oliver Hill", "image": "", "targetText": "Brown v. Board case", "targetImage": "" },
          { "id": "bank_lead", "text": "Maggie Walker", "image": "", "targetText": "Opened bank", "targetImage": "" },
          { "id": "governor_va", "text": "L. Douglas Wilder", "image": "", "targetText": "Governor of Virginia", "targetImage": "" }
        ]
      }
    ]
  },
  
  
  // Abraham Lincoln - Multiple Choice
  {
    "slug": "abrahamlincoln",
    "title": "Abraham Lincoln",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What number President of the United States was Abraham Lincoln?",
        "questionImage": "",
        "answers": [
          { "text": "16th", "correct": true, "image": "" },
          { "text": "1st", "correct": false, "image": "" },
          { "text": "3rd", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. In which state was Abraham Lincoln born?",
        "questionImage": "",
        "answers": [
          { "text": "Kentucky", "correct": true, "image": "" },
          { "text": "Virginia", "correct": false, "image": "" },
          { "text": "New York", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is Abraham Lincoln best known for during the Civil War?",
        "questionImage": "",
        "answers": [
          { "text": "Freeing enslaved people", "correct": true, "image": "" },
          { "text": "Starting a new war", "correct": false, "image": "" },
          { "text": "Building railroads", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which war took place while Abraham Lincoln was President?",
        "questionImage": "",
        "answers": [
          { "text": "Civil War", "correct": true, "image": "" },
          { "text": "Revolutionary War", "correct": false, "image": "" },
          { "text": "World War I", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Before becoming President, what job did Abraham Lincoln have?",
        "questionImage": "",
        "answers": [
          { "text": "Lawyer", "correct": true, "image": "" },
          { "text": "Doctor", "correct": false, "image": "" },
          { "text": "Farmer", "correct": false, "image": "" }
        ]
      }
    ]
  },
  
  
  // Benjamin Franklin - Multiple Choice
  {
    "slug": "benjaminfranklin",
    "title": "Benjamin Franklin",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Which helpful item for seeing clearly did Benjamin Franklin invent?",
        "questionImage": "",
        "answers": [
          { "text": "Bifocals", "correct": true, "image": "" },
          { "text": "Microscope", "correct": false, "image": "" },
          { "text": "Telescope", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What did Franklin’s kite experiment help show about lightning?",
        "questionImage": "",
        "answers": [
          { "text": "It’s electricity", "correct": true, "image": "" },
          { "text": "It’s magnetism", "correct": false, "image": "" },
          { "text": "It’s gravity", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which important document did Benjamin Franklin help write?",
        "questionImage": "",
        "answers": [
          { "text": "Declaration of Independence", "correct": true, "image": "" },
          { "text": "Bill of Rights", "correct": false, "image": "" },
          { "text": "Gettysburg Address", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which other important document did Benjamin Franklin sign?",
        "questionImage": "",
        "answers": [
          { "text": "U.S. Constitution", "correct": true, "image": "" },
          { "text": "Emancipation Proclamation", "correct": false, "image": "" },
          { "text": "Homestead Act", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Did Benjamin Franklin ever serve as President of the United States?",
        "questionImage": "",
        "answers": [
          { "text": "No", "correct": true, "image": "" },
          { "text": "Yes", "correct": false, "image": "" },
          { "text": "Maybe", "correct": false, "image": "" }
        ]
      }
    ]
  },
  
  
  // Producer - Drag and Drop
  {
    "slug": "producer",
    "title": "Producer",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each economic role to what it does.",
        "options": [
          { "id": "producer_goods", "text": "Producer", "image": "", "targetText": "Makes goods", "targetImage": "" },
          { "id": "producer_services", "text": "Producer", "image": "", "targetText": "Gives services", "targetImage": "" },
          { "id": "consumer_uses", "text": "Consumer", "image": "", "targetText": "Uses products", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each example to whether it shows a producer or consumer.",
        "options": [
          { "id": "baker", "text": "Baker", "image": "", "targetText": "Producer", "targetImage": "" },
          { "id": "teacher", "text": "Teacher", "image": "", "targetText": "Producer", "targetImage": "" },
          { "id": "shopper", "text": "Shopper", "image": "", "targetText": "Consumer", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each word to what it means in the economy.",
        "options": [
          { "id": "scarcity", "text": "Scarcity", "image": "", "targetText": "Not enough of something", "targetImage": "" },
          { "id": "choice", "text": "Choice", "image": "", "targetText": "Picking one thing", "targetImage": "" },
          { "id": "resource", "text": "Resource", "image": "", "targetText": "Something used to make goods", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each type of resource to what it is used for.",
        "options": [
          { "id": "human_resource", "text": "Human", "image": "", "targetText": "Workers and skills", "targetImage": "" },
          { "id": "natural_resource", "text": "Natural", "image": "", "targetText": "From nature", "targetImage": "" },
          { "id": "capital_resource", "text": "Capital", "image": "", "targetText": "Tools and machines", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each concept to what it helps people do in the economy.",
        "options": [
          { "id": "buy_sell", "text": "Buy and sell", "image": "", "targetText": "Trade goods", "targetImage": "" },
          { "id": "save_spend", "text": "Save and spend", "image": "", "targetText": "Use money", "targetImage": "" },
          { "id": "work_earn", "text": "Work and earn", "image": "", "targetText": "Make income", "targetImage": "" }
        ]
      }
    ]
  },
  
  
  // Wants and Choices - Drag and Drop
  {
    "slug": "wantsandchoices",
    "title": "Wants and Choices",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each term to what it means.",
        "options": [
          { "id": "wants", "text": "Wants", "image": "", "targetText": "Things we’d like to have", "targetImage": "" },
          { "id": "needs", "text": "Needs", "image": "", "targetText": "Things we must have", "targetImage": "" },
          { "id": "choices", "text": "Choices", "image": "", "targetText": "Decisions we make", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each example to what it shows.",
        "options": [
          { "id": "food", "text": "Food", "image": "", "targetText": "Need", "targetImage": "" },
          { "id": "toy", "text": "Toy", "image": "", "targetText": "Want", "targetImage": "" },
          { "id": "water", "text": "Water", "image": "", "targetText": "Need", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each decision to what it shows about choices.",
        "options": [
          { "id": "game_snack", "text": "Game or snack", "image": "", "targetText": "Making a choice", "targetImage": "" },
          { "id": "toy_book", "text": "Toy or book", "image": "", "targetText": "Making a choice", "targetImage": "" },
          { "id": "tv_homework", "text": "TV or homework", "image": "", "targetText": "Choosing one", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each word to how it connects to scarcity.",
        "options": [
          { "id": "scarcity", "text": "Scarcity", "image": "", "targetText": "Not enough of something", "targetImage": "" },
          { "id": "limited", "text": "Limited", "image": "", "targetText": "Few resources", "targetImage": "" },
          { "id": "choices2", "text": "Choices", "image": "", "targetText": "We must decide", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each reason people can’t have everything to the right idea.",
        "options": [
          { "id": "money", "text": "Money", "image": "", "targetText": "Limited resource", "targetImage": "" },
          { "id": "time", "text": "Time", "image": "", "targetText": "We can’t do it all", "targetImage": "" },
          { "id": "scarce_items", "text": "Scarce items", "image": "", "targetText": "Not enough for everyone", "targetImage": "" }
        ]
      }
    ]
  },
  
  
  // Responsible Citizen - Multiple Choice
  {
    "slug": "responsiblecitizen",
    "title": "Responsible Citizen",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What is something good citizens should always do in their community?",
        "questionImage": "",
        "answers": [
          { "text": "Obey laws", "correct": true, "image": "" },
          { "text": "Break laws", "correct": false, "image": "" },
          { "text": "Ignore rules", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What civic duty asks citizens to help decide court cases?",
        "questionImage": "",
        "answers": [
          { "text": "Serve on a jury", "correct": true, "image": "" },
          { "text": "Go to a parade", "correct": false, "image": "" },
          { "text": "Vote for a friend", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What duty helps pay for roads, schools, and services in a community?",
        "questionImage": "",
        "answers": [
          { "text": "Pay taxes", "correct": true, "image": "" },
          { "text": "Skip taxes", "correct": false, "image": "" },
          { "text": "Hide taxes", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. When should citizens serve their community or country if they are asked?",
        "questionImage": "",
        "answers": [
          { "text": "When called to serve", "correct": true, "image": "" },
          { "text": "Only on holidays", "correct": false, "image": "" },
          { "text": "Never", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What should each of us try to be in our community?",
        "questionImage": "",
        "answers": [
          { "text": "A responsible citizen", "correct": true, "image": "" },
          { "text": "A careless neighbor", "correct": false, "image": "" },
          { "text": "A litter bug", "correct": false, "image": "" }
        ]
      }
    ]
  },
  
  
  // Pledge - Multiple Choice
  {
    "slug": "pledge",
    "title": "Pledge",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What is the title of the person who leads the United States government?",
        "questionImage": "",
        "answers": [
          { "text": "President", "correct": true, "image": "" },
          { "text": "King", "correct": false, "image": "" },
          { "text": "Duke", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What are the three colors on the flag of the United States?",
        "questionImage": "",
        "answers": [
          { "text": "Red, white, and blue", "correct": true, "image": "" },
          { "text": "Green and gold", "correct": false, "image": "" },
          { "text": "Black and white", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What shapes appear as symbols in the blue field of the flag?",
        "questionImage": "",
        "answers": [
          { "text": "White stars", "correct": true, "image": "" },
          { "text": "Green stars", "correct": false, "image": "" },
          { "text": "No stars", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What do we recite together in schools to show love for our country?",
        "questionImage": "",
        "answers": [
          { "text": "Pledge of Allegiance", "correct": true, "image": "" },
          { "text": "National Poem", "correct": false, "image": "" },
          { "text": "Library Oath", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. To whom or what do we give our pledge during the Pledge of Allegiance?",
        "questionImage": "",
        "answers": [
          { "text": "The Flag of the United States", "correct": true, "image": "" },
          { "text": "Our school", "correct": false, "image": "" },
          { "text": "Our town", "correct": false, "image": "" }
        ]
      }
    ]
  },
  
  
  // VA State Bird - Multiple Choice
  {
    "slug": "vastatebird",
    "title": "VA State Bird",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What is the official state bird of Virginia?",
        "questionImage": "",
        "answers": [
          { "text": "Cardinal", "correct": true, "image": "" },
          { "text": "Bluebird", "correct": false, "image": "" },
          { "text": "Robin", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What color is the male Virginia cardinal?",
        "questionImage": "",
        "answers": [
          { "text": "Red", "correct": true, "image": "" },
          { "text": "Blue", "correct": false, "image": "" },
          { "text": "Green", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What color is the female Virginia cardinal?",
        "questionImage": "",
        "answers": [
          { "text": "Brown", "correct": true, "image": "" },
          { "text": "Red", "correct": false, "image": "" },
          { "text": "Yellow", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What type of bird is the cardinal known to be?",
        "questionImage": "",
        "answers": [
          { "text": "Songbird", "correct": true, "image": "" },
          { "text": "Seabird", "correct": false, "image": "" },
          { "text": "Penguin", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. In which year did the cardinal become Virginia’s official state bird?",
        "questionImage": "",
        "answers": [
          { "text": "1950", "correct": true, "image": "" },
          { "text": "1776", "correct": false, "image": "" },
          { "text": "2001", "correct": false, "image": "" }
        ]
      }
    ]
  },
  
  
  // VA State Flag - Drag and Drop
  {
    "slug": "vastateflag",
    "title": "VA State Flag",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each part of the Virginia state flag to its description.",
        "options": [
          { "id": "background", "text": "Background", "image": "", "targetText": "Dark blue", "targetImage": "" },
          { "id": "center_seal", "text": "Center", "image": "", "targetText": "State seal", "targetImage": "" },
          { "id": "border", "text": "Border", "image": "", "targetText": "Red leaves and flowers", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match what appears on the state seal to what it represents.",
        "options": [
          { "id": "virtus", "text": "Virtus", "image": "", "targetText": "Bravery", "targetImage": "" },
          { "id": "fallen_tyrant", "text": "Fallen Tyrant", "image": "", "targetText": "Defeated evil", "targetImage": "" },
          { "id": "crown", "text": "Broken Crown", "image": "", "targetText": "Freedom from rule", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each flag detail to what it tells about Virginia.",
        "options": [
          { "id": "seal_text", "text": "Sic Semper Tyrannis", "image": "", "targetText": "State motto", "targetImage": "" },
          { "id": "virtus_sword", "text": "Virtus with sword", "image": "", "targetText": "Protects liberty", "targetImage": "" },
          { "id": "tyrant_down", "text": "Tyrant on ground", "image": "", "targetText": "Defeated power", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match the flag’s colors and symbols to what they mean.",
        "options": [
          { "id": "blue_color", "text": "Blue background", "image": "", "targetText": "Loyalty", "targetImage": "" },
          { "id": "white_seal", "text": "White seal", "image": "", "targetText": "Peace", "targetImage": "" },
          { "id": "red_border", "text": "Red border", "image": "", "targetText": "Courage", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each fact about the flag to the correct detail.",
        "options": [
          { "id": "adopt_year", "text": "Adopted", "image": "", "targetText": "1861", "targetImage": "" },
          { "id": "design_type", "text": "Design", "image": "", "targetText": "Circular seal on blue field", "targetImage": "" },
          { "id": "motto_location", "text": "Motto words", "image": "", "targetText": "On state seal", "targetImage": "" }
        ]
      }
    ]
  },
  
  
  // VA State Flower - Drag and Drop
  {
    "slug": "vastateflower",
    "title": "VA State Flower",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each fact about Virginia’s state flower to the correct word.",
        "options": [
          { "id": "dogwood", "text": "Dogwood", "image": "", "targetText": "State flower", "targetImage": "" },
          { "id": "virginia", "text": "Virginia", "image": "", "targetText": "State it represents", "targetImage": "" },
          { "id": "official", "text": "Official", "image": "", "targetText": "Named by law", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each part of the dogwood flower to how it looks.",
        "options": [
          { "id": "petals", "text": "Petals", "image": "", "targetText": "Four white petals", "targetImage": "" },
          { "id": "center", "text": "Center", "image": "", "targetText": "Green clusters", "targetImage": "" },
          { "id": "leaves", "text": "Leaves", "image": "", "targetText": "Bright green", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match the season or reason connected to the dogwood flower.",
        "options": [
          { "id": "spring", "text": "Spring", "image": "", "targetText": "When it blooms", "targetImage": "" },
          { "id": "beauty", "text": "Beauty", "image": "", "targetText": "Symbol of the state", "targetImage": "" },
          { "id": "strength", "text": "Strength", "image": "", "targetText": "Grows across Virginia", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each fact about the dogwood to its meaning or description.",
        "options": [
          { "id": "tree_type", "text": "Flowering tree", "image": "", "targetText": "Grows small and wide", "targetImage": "" },
          { "id": "bloom_color", "text": "White bloom", "image": "", "targetText": "Most common color", "targetImage": "" },
          { "id": "pink_bloom", "text": "Pink bloom", "image": "", "targetText": "Less common variety", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each historical fact to the correct date or reason.",
        "options": [
          { "id": "since_1918", "text": "Since 1918", "image": "", "targetText": "Named official flower", "targetImage": "" },
          { "id": "chosen", "text": "Chosen", "image": "", "targetText": "By General Assembly", "targetImage": "" },
          { "id": "honor", "text": "Honor", "image": "", "targetText": "State pride", "targetImage": "" }
        ]
      }
    ]
  },
  
  
  // Capitol Building - Multiple Choice
  {
    "slug": "capitolbuilding",
    "title": "Capitol Building",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Which group meets in the United States Capitol Building to do their work?",
        "questionImage": "",
        "answers": [
          { "text": "Congress", "correct": true, "image": "" },
          { "text": "Supreme Court", "correct": false, "image": "" },
          { "text": "Cabinet", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. In which city is the United States Capitol Building located?",
        "questionImage": "",
        "answers": [
          { "text": "Washington, D.C.", "correct": true, "image": "" },
          { "text": "Richmond, Virginia", "correct": false, "image": "" },
          { "text": "Boston, Massachusetts", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What are the names of the two groups that make up the United States Congress?",
        "questionImage": "",
        "answers": [
          { "text": "Senate and House of Representatives", "correct": true, "image": "" },
          { "text": "President and Court", "correct": false, "image": "" },
          { "text": "Mayor and Council", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is the main job of Congress when they meet at the Capitol?",
        "questionImage": "",
        "answers": [
          { "text": "Make laws", "correct": true, "image": "" },
          { "text": "Hold concerts", "correct": false, "image": "" },
          { "text": "Plan parties", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is the name of the statue that stands on top of the Capitol dome?",
        "questionImage": "",
        "answers": [
          { "text": "Statue of Freedom", "correct": true, "image": "" },
          { "text": "Statue of Liberty", "correct": false, "image": "" },
          { "text": "Lincoln Statue", "correct": false, "image": "" }
        ]
      }
    ]
  },
  
  
  // American Flag - Multiple Choice
  {
    "slug": "americanflagmc",
    "title": "American Flag",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. How many stars appear on the flag of the United States today?",
        "questionImage": "",
        "answers": [
          { "text": "50", "correct": true, "image": "" },
          { "text": "13", "correct": false, "image": "" },
          { "text": "25", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How many stripes are on the flag of the United States?",
        "questionImage": "",
        "answers": [
          { "text": "13", "correct": true, "image": "" },
          { "text": "10", "correct": false, "image": "" },
          { "text": "20", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What do the stars on the United States flag represent?",
        "questionImage": "",
        "answers": [
          { "text": "50 states", "correct": true, "image": "" },
          { "text": "13 colonies", "correct": false, "image": "" },
          { "text": "Presidents", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What do the stripes on the United States flag stand for?",
        "questionImage": "",
        "answers": [
          { "text": "13 colonies", "correct": true, "image": "" },
          { "text": "50 states", "correct": false, "image": "" },
          { "text": "Rivers", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What feeling or value does the American flag often show?",
        "questionImage": "",
        "answers": [
          { "text": "Patriotism", "correct": true, "image": "" },
          { "text": "Weather", "correct": false, "image": "" },
          { "text": "Music", "correct": false, "image": "" }
        ]
      }
    ]
  },
  
  
  // VA United - Multiple Choice
  {
    "slug": "vaunited",
    "title": "VA United",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What do we call the people who live in the United States of America?",
        "questionImage": "",
        "answers": [
          { "text": "Americans", "correct": true, "image": "" },
          { "text": "Robots", "correct": false, "image": "" },
          { "text": "Aliens", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which civic action lets people choose their leaders and share their voice?",
        "questionImage": "",
        "answers": [
          { "text": "Vote", "correct": true, "image": "" },
          { "text": "Litter", "correct": false, "image": "" },
          { "text": "Speed", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What can people in a community do to choose who leads their town or city?",
        "questionImage": "",
        "answers": [
          { "text": "Elect leaders", "correct": true, "image": "" },
          { "text": "Skip laws", "correct": false, "image": "" },
          { "text": "Close parks", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How can people help make their community a better place to live?",
        "questionImage": "",
        "answers": [
          { "text": "Volunteer", "correct": true, "image": "" },
          { "text": "Ignore problems", "correct": false, "image": "" },
          { "text": "Complain only", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Where do the people of Virginia come from, and what does that show about our state?",
        "questionImage": "",
        "answers": [
          { "text": "Many places", "correct": true, "image": "" },
          { "text": "One town", "correct": false, "image": "" },
          { "text": "One family", "correct": false, "image": "" }
        ]
      }
    ]
  }
  
  
];

export default va1stSocialStudiesQuizContent;
